import React from 'react'
import {connect} from 'react-redux'
import {createStructuredSelector} from 'reselect'

import * as ab from '../../../store/ab'
import * as cross from '../../../store/cross'
import * as nearestShowroomSelectors from '../../../store/nearestShowrooms'
import * as pdp from '../../../store/productDetailPage'
import * as reviews from '../../../store/reviews'
import {NearestShowroomLocation} from '../../../typedefs/showrooms'
import Experiment from '../../Pieces/Experiment'
import Throbber from '../../Throbber'
import AddToLook from '../AddToLook'
import FitOptions from '../FitOptions'
import PdpRevampSection from '../PdpRevampSection'
import ReviewStarsNumber from '../Reviews/ReviewStarsNumber'
import ProductSidebarDescription from './ProductSidebarDescription'
import ProductSidebarDetailsList from './ProductSidebarDetailsList'
import ProductSidebarSizing from './ProductSidebarSizing'

interface Props {
  hasReviews: boolean
  isKit: boolean
  isParticipant: boolean
  nearestShowroom: NearestShowroomLocation
  productHasLoaded: boolean
  productName: string
  showBuyPathExperiment: boolean
}

const ProductSidebar: React.FC<Props> = ({
  hasReviews,
  isKit,
  isParticipant,
  nearestShowroom,
  productHasLoaded,
  productName,
  showBuyPathExperiment,
}) => {
  if (!productHasLoaded) {
    return <Throbber color="dark" />
  }
  return (
    <div className="c-product-sidebar">
      <div className="c-product-sidebar__section">
        <h1 className="c-product-sidebar__title">{productName}</h1>
        {isKit && (
          <div className="price-and-includes">
            <h2 className="includes-text">Includes Jacket & Pants</h2>
            {hasReviews && <ReviewStarsNumber />}
          </div>
        )}
      </div>
      {!isParticipant && (
        <div className="c-product-sidebar__section">
          <Experiment test={ab.LOOKBUILDER_PDP_ENTRYPOINT}>
            <AddToLook isKit={isKit} showBuyPathExperiment={showBuyPathExperiment} />
          </Experiment>
          <Experiment test={ab.LOOKBUILDER_PDP_ENTRYPOINT} variation={1}>
            <PdpRevampSection />
          </Experiment>
        </div>
      )}
      <div className="c-product-sidebar__section">
        <h3 className="c-product-sidebar__subheading">Sizes</h3>
        <ProductSidebarSizing />
      </div>
      <div className="c-product-sidebar__section">
        <h3 className="c-product-sidebar__subheading">Details</h3>
        <ProductSidebarDescription />
        <ProductSidebarDetailsList />
      </div>
      {!!nearestShowroom && (
        <div className="c-product-sidebar__section">
          <FitOptions nearestShowroom={nearestShowroom} />
        </div>
      )}
    </div>
  )
}

const mapStateToProps = createStructuredSelector({
  hasReviews: reviews.hasReviews,
  isKit: pdp.productIsKit,
  isParticipant: cross.userIsParticipant,
  nearestShowroom: nearestShowroomSelectors.nearestShowroom,
  productHasLoaded: pdp.productHasLoaded,
  productName: pdp.productName,
})

export default connect(mapStateToProps)(ProductSidebar)
